export default "__VITE_ASSET__DJ9RMmU6__"